import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressBar, MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule,MatProgressBarModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css',
  selector: 'app-loader'
})
export class LoaderComponent {
  @Input() loaderType: string = 'progress-bar';
  
}

// progress-bar
// cat-loader
